module.exports = __webpack_public_path__ + "img/CHILD LABOUR.bde9359f.jpg";